import React from "react";
import IndustryGroups from "./IndustryGroups";
import MainCategoryMaster from "./MainCategoryMaster";
import FamilyMaster from "./FamilyMaster";

const AdminCategories = () => {
  return (
    <div className="container-fluid p-0" style={{ backgroundColor: "transparent" }}>
      <div className="mb-5">
        <IndustryGroups />
      </div>
      <div className="mb-5 pt-4 border-top">
        <MainCategoryMaster />
      </div>
      <div className="mb-5 pt-4 border-top">
        <FamilyMaster />
      </div>
    </div>
  );
};

export default AdminCategories;